import * as React from 'react';
import EnquiryResultTableViewHeader from './EnquiryResultTableViewHeader';
import EnquiryResultTableViewCell from './EnquiryResultTableViewCell';
import {CoverNote} from '../../Config/dataModel';
import Translator from '../Translator/Translator';

interface EnquiryResultTableViewProps {
    list: CoverNote[],
    clickCell: (idx: number) => void,
    clickClose: () => void
}

class EnquiryResultTableView extends React.Component <EnquiryResultTableViewProps, {}> {
    public getEnquiryResultTableView() {
        let cells = [];
        for (let i = 0; i < this.props.list.length; i++) {
            const data = this.props.list[i].state.data;
            cells.push(
                <EnquiryResultTableViewCell
                    key={i}
                    idx={i}
                    chassisNo={data.props.chassisNumber}
                    license={data.props.licensePlateNumber}
                    endDate={data.props.policyEndDate}
                    clickCell={(idx) => this.props.clickCell(idx)}
                />);
        }
        return cells;
    }

    public render() {
        return (
            <div>
                <div className="enquiryTableWrapper">
                    <EnquiryResultTableViewHeader/>
                    {this.getEnquiryResultTableView()}
                </div>
                <div className="cmHorCenter enquiryBtnsContainer">
                    <button className="cmBtn cmCenterBtn cmBlueBtn cmBoldText" onClick={(e) => this.props.clickClose()}>
                        <Translator path="enquiry.form.btn.close">Close</Translator>
                    </button>
                </div>
            </div>
        );
    }
}

export default EnquiryResultTableView;


// WEBPACK FOOTER //
// ./src/Components/Enquiry/EnquiryResultTableView.tsx